var map = {
	"./article-1.jpg": 2919,
	"./background.png": 9435,
	"./bg-05.png": 162,
	"./cont-mail.png": 4230,
	"./cont-phone.png": 2424,
	"./contact-background.png": 4570,
	"./error-404.jpg": 6010,
	"./footer-bg.jpg": 5160,
	"./gmail-logo.png": 4466,
	"./gmail-logo.svg": 5276,
	"./grp-bg-img.png": 3973,
	"./icon.png": 286,
	"./image-6.png": 6509,
	"./logo-1.png": 2126,
	"./phone-1.png": 739,
	"./phone.svg": 5244,
	"./place-marker.svg": 5761,
	"./placemarker.png": 1144,
	"./placemarkercontact.svg": 6708,
	"./products.png": 8440,
	"./profile.png": 1989,
	"./rating.png": 1154,
	"./services-1.jpg": 3172,
	"./services-2.jpg": 3260,
	"./services-3.jpg": 1235,
	"./services-4.jpg": 2651,
	"./services-icon-1.jpg": 4191,
	"./services-icon-2.jpg": 4393,
	"./services-icon-3.jpg": 81,
	"./services-icon-4.jpg": 1213,
	"./tube.png": 241,
	"./white-logo.png": 8990
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5837;